export const makePaymentViaTazapay = (internalResponse: any) => {
    if (internalResponse?.data?.redirect_url)
        window.location.href = internalResponse?.data?.redirect_url;
};
